import script from "./AuditDetailsComments.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuditDetailsComments.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__